import React, { useEffect, useState } from 'react';
import { Button, Text, View } from "../../Components/Themed"
import type { AthleteProps, BestAvailableOrderProps, GolfCourseProps, GolfHoleProps, GolfLeaderProps, GolfScorecardProps, GolfTournamentStatisticsProps, MarketProps, MarketSideOptionProps, OrderProps, TournamentProps, TradeProps } from '../../types';
import { ActivityIndicator, FlatList } from 'react-native';
import { GolfApi, GolfHelpers } from '../api';
import { Icons } from '../../Components';
import { useColors } from '../../constants/useColors';
import MarketButton from '../../MarketComponents/components/MarketButton';
import { MarketComponentHelpers } from '../../MarketComponents/api';
import { MarketButtonHelpers } from '../../MarketComponents/components/MarketButton/api';
import { AthleteImage } from '../../Components/Jerseys';
import moment from 'moment-mini';

type LeaderBetSelectorProps = {
    tournament:TournamentProps,
    my_orders: OrderProps[],
    best_available_orders:BestAvailableOrderProps[],
    latest_trades:TradeProps[],
    golf_leader:GolfLeaderProps,
    golf_course:GolfCourseProps,
    athlete:AthleteProps,
    markets:MarketProps[],
    golf_statistics?:GolfTournamentStatisticsProps,
    prior_year?:boolean,
    active_round?:number,
    onClose:() => void,
    onOrder:(order:OrderProps) => void
}
const leader_bet_sections = ['leader','market_details','holes']

const LeaderBetSelector = ({ athlete, golf_leader, my_orders, golf_statistics, prior_year, best_available_orders, latest_trades, tournament, markets, active_round, golf_course, onClose, onOrder }:LeaderBetSelectorProps) => {
    const [ leader_data, setLeaderData ] = useState<{
        loading:boolean,
        scorecards:GolfScorecardProps[]
    }>({
        loading:false,
        scorecards:[]
    });
    const { loading, scorecards } = leader_data

    useEffect(() => {
        getData();
    },[athlete?.athlete_id]);
    let athlete_orders = my_orders.filter(o => o.side_id == athlete.athlete_id);

    const getData = async() => {
        setLeaderData({ ...leader_data, loading:true });
        const scorecards = await GolfApi.getScorecard(tournament.tournament_id, athlete.athlete_id, active_round);
        let score_card = scorecards.filter(c => c.athlete_id == athlete.athlete_id && c.round_number == active_round);
        setLeaderData({
            loading:false,
            scorecards: score_card
        })
    }
    const Colors = useColors();
    const current_hole = GolfHelpers.getCurrentHole(golf_leader, active_round);
    const renderSides = (data:{ item:MarketSideOptionProps, index:number, market:MarketProps, trades:TradeProps[], orders:OrderProps[] }) => {

        let ba_order = best_available_orders.find(o => o.market_id == data.market.market_id && o.side_type == 'athlete' && o.side_id == athlete.athlete_id && o.side == data.item.side && o.show);
        const side_details = MarketComponentHelpers.getTournamentSideIds(data.market, data.item, athlete, undefined);
        if(!side_details){ return <></> }
        let trade = MarketButtonHelpers.getVisibleTrade('best_available', data.market, data.item, latest_trades, best_available_orders, side_details.side_id, side_details.reversed_side_id); 
        if(!trade){
            trade = data.trades.find(t => t.side == data.item.side);
            if(!trade){
                trade = MarketButtonHelpers.getTradeFromMarket(data.market, tournament.tournament_id, 'team', data.item.side, data.item.id_source, side_details.side_id, side_details.reversed_side_id);
            }
        }
        trade = GolfHelpers.addTradeBuffer(trade, data.market, 0.04);
        /*
        if(!ba_order){
            ba_order = GolfHelpers.generateBestAvailableOrder(trade);
            const order_title = MarketComponentHelpers.getOrderTitleForTournament(ba_order, data.market, tournament, athlete);
            if(order_title){ ba_order.title = order_title }
        }
        */
       let side_order = data.orders.find(o => o.side == data.item.side);
        return (
            <View key={`${tournament.tournament_id}_${athlete.athlete_id}_${data.item.side}`} style={{ margin:2, height:50, width:75 }}>
                <MarketButton
                    side_option={data.item}
                    market={data.market}
                    trade={trade}
                    show_grades={false}
                    locked={side_order ? true: false}
                    order={ba_order}
                    onLongPress={() => console.log('LONG PRESSED')}
                    onPress={(order) => {
                        const order_title = MarketComponentHelpers.getOrderTitleForTournament(order, data.market, tournament, athlete);
                        if(!order_title){ return alert('Unable to process order') }
                        onOrder({ ...order, title: order_title, league_id: tournament.league_id })
                    }}
                />
            </View>
        )
    }

    const renderHoles = (data:{ item:GolfHoleProps, index:number }) => {
        const market = markets.find(m => m.length_variable == data.item.number);
        const stats = GolfHelpers.getHoleStats(data.item.number, golf_statistics, active_round);
        const active = current_hole == data.item.number
        const score = scorecards.find(s => s.hole_number == data.item.number && s.round_number == active_round);
        if(!score){ return <></> }

        
        let allowed = false
        let completed = true

        if(score.strokes == 0 && market){
            completed = false
            if(score.starting_hole == 1 && data.item.number > (current_hole + 1)){ allowed = true }
            if(score.starting_hole == 10 && current_hole < 10 && data.item.number > (current_hole + 1)){ allowed = true }
            if(score.starting_hole == 10 && current_hole >= 10){
                if(data.item.number > 9 && data.item.number > (current_hole + 1)){ allowed = true }
                if(data.item.number <= 9){
                    let refreshed_hole_number = data.item.number + 18
                    if(refreshed_hole_number > (current_hole + 1)){ allowed = true }
                }
                
            }
        }



        //const allowed = current_hole == 0 ? true : data.item.number > (current_hole + 1) && market ? true : false
        //const completed = current_hole > data.item.number ? true : false
        const trades = GolfHelpers.getParTradeFromHoleStats(tournament.tournament_id, athlete, market, stats);
        const active_hole_orders = athlete_orders.filter(o => o.market_id == market?.market_id && o.resolution_status == 'inprogress');

        return (
            <View style={{ flexDirection:'row', alignItems:'center', padding:10, borderBottomWidth:1, borderColor:Colors.borders.light, backgroundColor:completed ? Colors.views.header : undefined }}>
                {active ?
                <Icons.GolferIcon color={Colors.text.h1} size={20} />
                :<></>}
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h2'>Hole {data.item.number} {'\u2022'} Par {data.item.par}</Text>
                    {stats ?
                    <Text theme='description' style={{ marginTop:4 }}>Avg Strokes: {stats.strokes_avg}{prior_year?` (${moment().subtract(1,'year').format('YYYY')})`:''}</Text>
                    :<></>}
                </View>
                <View transparent>
                    {allowed && market && trades ?
                    <View style={{ flexDirection:'row', alignItems:'center' }}>
                        <FlatList
                            data={market.side_options}
                            key={'side_options_bet_leader'}
                            horizontal
                            keyExtractor={(item) => `${market.market_id}_${item.side}`}
                            renderItem={({ item, index }) => renderSides({ item, index, market, trades, orders:active_hole_orders })}

                        />
                    </View>
                    :
                    <View transparent style={{ flexDirection:'row', alignItems:'center' }}>
                        {score && completed?
                        <Text style={{ marginRight:10 }} theme='h2' color={score.strokes < data.item.par ? Colors.text.error : Colors.text.action}>{score.strokes}</Text>
                        :<></>}
                        <Button disabled float style={{ padding:10 }}>
                            <Icons.LockClosedIcon color={Colors.text.h1} size={16} />
                        </Button>
                    </View>
                    }
                </View>
            </View>
        )
    }

    const renderSections = (data: { item:string, index:number }) => {
        switch(data.item){
            case 'market_details':
                return (
                    <View type='header' style={{ borderTopWidth:1, borderColor:Colors.borders.light, padding:10 }}>
                        <Text theme='h2'>Par Betting</Text>
                        <Text theme='description' style={{ marginTop:4 }}>Bet on over / under par on each hole!  Par results in a no-bet.</Text>
                    </View>
                )
            case 'holes':
                return (
                    <FlatList
                        data={golf_course.holes.sort((a,b) => b.number - a.number)}
                        key={'hole_list_bet_leader'}
                        keyExtractor={(item) => `${item.number}_bet_leader`}
                        renderItem={renderHoles}
                    />
                )
            default: return <></>
        }
    }
    return (
        <View type='blur' style={{ position:'absolute', flex:1, bottom:0, left:0, right:0, top:0 }}>
            <View float style={{ flex:1 }}>
                <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10, borderTopRightRadius:8, borderTopLeftRadius:8 }}>
                    <AthleteImage
                        athlete={athlete}
                        size={32}
                    />
                    <View transparent style={{ flex:1, marginLeft:10 }}>
                        <Text theme='h1'>{athlete.first_name} {athlete.last_name}</Text>
                        <Text theme='description' style={{ marginTop:4 }}>Current Hole {current_hole}</Text>
                    </View>
                    <Text theme='h1' color={golf_leader.score < 0 ?Colors.text.error : Colors.text.action}>{golf_leader.score_label}</Text>
                    <Button
                        title='X'
                        float
                        style={{ marginLeft:15, height:30, width:30, borderRadius:100, padding:0, justifyContent:'center', alignItems:'center' }}
                        onPress={() => onClose()}
                    />
                </View>
                <View transparent style={{ flex:1 }}>
                    {loading ?
                    <ActivityIndicator
                        style={{ padding:10, alignSelf:'center' }}
                        color={Colors.text.h1}
                    /> 
                    :<></>}
                    <FlatList
                        key='list_bet_leader_sections'
                        keyExtractor={(item) => item}
                        renderItem={renderSections}
                        data={leader_bet_sections}
                    />
                </View>
            </View>
        </View>
    )
}

export default LeaderBetSelector